'use client';
import { createStyles, rem } from '@s7/styles';

var useStyles = createStyles((theme, { width, height, fit })=>{
    return {
        root: {},
        image: {
            objectFit: fit,
            width: !width ? '100%' : undefined,
            height: !height ? '100%' : undefined
        },
        fallback: {
            background: theme.palette.background.element,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: width ? rem(width) : '100%',
            height: height ? rem(height) : '100%',
            ['&[data-fallback="placeholder"]']: {
                background: 'transparent'
            }
        }
    };
});

export { useStyles as default };
//# sourceMappingURL=Image.styles.js.map
